import React from 'react';
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
// import './Header.scss';
import './Header2.scss';
// import Particles from '../../components/Particles';

const scaleVariants = {
  whileInView:{
    scale: [0,1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>

      {/* this i made for my name*/}
      <motion.div 
        whileInView={ { x : [-100, 0], opacity: [0,1]}}
        transition = {{duration: 0.5}}
        className='app__header-info'
      >
        <div className='app__header-coder'>
            <h2 className='app__header-coder-title'><span>&lt;</span>CODER<span>&gt;</span></h2>

            <h3 className='app__header-webdev'>WEB DEVELOPER AND CODER</h3>
            <p className='app__header-desc '>I am a full stack developer with experience in ReactJS, Javascript, MongoDB and NodeJS. </p>
            <img src = {images.leftdescrect} alt ='leftdesrec' className='app__header-leftdescimg'></img>
            {/* <div classname='leftdescrec'></div> */}
        </div>
      </motion.div >

      {/* this i made for circle behind me*/}
      <motion.div
        whileInView={ { opacity: [0,1]}}
        transition = {{duration: 0.5, delayChildren: 0.5}}
        className='app__header-img'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span> 👋 </span>
            <div style =  {{marginLeft: 20}}>
              <p className='p-text helloiam' > Hello, I am </p>
              {/* <h6 className=''> Hello, I am </h6> */}
              <h1 className='head-text'>Naman</h1>

            </div>
          </div>
          
        </div>
        
        <img src = {images.profile} alt ='profile_bg'></img>
       

      </motion.div>

       {/* <motion.img
          whileInView={ { scale: [0,1]}}
          transition = {{duration: 1, ease: 'easeInOut'}}
          className='overlay_circle'
          src = {images.circle}
          alt = 'profile_circle'
          
        /> */}
        

      {/* this i made for langauages floating at back*/}  
      <motion.div
        variant = {scaleVariants}
        whileInView = {scaleVariants.whileInView}
        className='app__header-designerr'
      >

        {/* {[images.figma, images.mu5, images.react,images.nodejs,images.redux].map((circles,index) => 
          <div className='circle-cmp app__flex' key = {`circle-${index}`}>
            <img src = {circles} alt = 'circle'/>
          </div>
        )} */}

        <div className='app__header-designer'>
            <h2 className='app__header-designer-title'>DES<span><img src = {images.idesign} alt ='idesign' id='idesign'></img></span>GNER</h2>

            <h3 className='app__header-uxdesigner'>UI/UX AND GRAPHIC DESIGNER</h3>
            <p className='app__header-desdesc'>I love to design eye-catchy visuals and graphics based on latest design trends using Figma, Adobe Photoshop and Adobe Illustrator. </p>
            <img src = {images.rightdescrect} alt ='rightdesrec' className='app__header-rightdescimg'></img>
        </div>

        
      </motion.div>
      {/* <div app__header-bgdesign>
        <Particles id="tsparticles" />
      </div> */}
      {/* <div className='app__header-aboutme'>
            <p className='app__header-aboutme-para'>I love to design eye-catchy visuals and graphics based on latest design trends using Figma, Adobe Photoshop and Adobe Illustrator.</p>

        </div> */}

    </div>
  )
}

export default AppWrap(Header, 'home');
// export default Header;
